// tslint:disable:max-line-length
import * as React from 'react';
import './Menu.css';
import { ClassNames } from '../../_helpers/ClassNames';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';

export type MenuProps = { menu: MenuDto; page: IPageDto } & RouteComponentProps;

export class MenuWrapped extends React.Component<MenuProps> {
  constructor(props: MenuProps) {
    super(props);
  }

  render() {
    const {
      location,
      menu: { OfficePage },
    } = this.props;

    return (
      <div className={ClassNames('menu', '')}>
        <nav className={ClassNames('menu', 'inner')}>
          <Link
            to={`/${OfficePage.UID}`}
            className={ClassNames('menu', 'logo')}
          >
            <span>Beer Merz</span>
            <span>
              Architekt:innen
              <br />
              <span style={{ fontSize: 21 }}>SIA BSA</span>
            </span>
          </Link>
          {location.pathname === '/buero' && (
            <div className={ClassNames('menu', 'instagram')}>
              <a
                href='https://www.instagram.com/beermerz/'
                target='_blank'
                rel='noreferrer'
                className={ClassNames('menu', 'instagram-link')}
              >
                <svg
                  version='1.1'
                  xmlns='http://www.w3.org/2000/svg'
                  x='0px'
                  y='0px'
                  viewBox='0 0 42 42'
                  enableBackground={'0 0 42 42'}
                >
                  <g transform='translate(0 0)'>
                    <g>
                      <g id='Gruppe_91' transform='translate(0 0)'>
                        <path
                          id='Pfad_1'
                          style={{ fill: '#161615' }}
                          d='M20.99,31.73c-5.93,0-10.73-4.81-10.73-10.74s4.81-10.73,10.74-10.73s10.73,4.81,10.73,10.74
												c0.01,5.92-4.79,10.73-10.71,10.73C21.01,31.73,21,31.73,20.99,31.73 M20.99,7.45c-7.48,0-13.54,6.07-13.54,13.55
												c0,7.48,6.07,13.54,13.55,13.54c7.48,0,13.54-6.06,13.54-13.54C34.53,13.52,28.47,7.45,20.99,7.45'
                        />
                        <path
                          id='Pfad_2'
                          style={{ fill: '#161615' }}
                          d='M34.28,5.61c-1.2,0-2.18,0.98-2.18,2.18s0.98,2.18,2.18,2.18S36.46,9,36.46,7.8
												C36.46,6.59,35.49,5.62,34.28,5.61C34.28,5.61,34.28,5.61,34.28,5.61'
                        />
                        <path
                          id='Pfad_3'
                          style={{ fill: '#161615' }}
                          d='M39.52,32.08c-0.01,4.11-3.34,7.44-7.45,7.44H9.93c-4.11,0-7.44-3.33-7.45-7.44V9.92
												c0.01-4.11,3.34-7.44,7.45-7.44h22.15c4.11,0,7.44,3.33,7.45,7.44V32.08z M32.08,0H9.93C4.45,0.01,0.02,4.45,0,9.92v22.15
												c0.02,5.47,4.46,9.9,9.93,9.92h22.15c5.48-0.01,9.91-4.45,9.92-9.92V9.92C42,4.45,37.55,0,32.08,0'
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </div>
          )}
          <div className={ClassNames('menu', 'menus-wrapper')}>
            {this._renderHomeLink()}
          </div>
        </nav>
      </div>
    );
  }
  private _renderHomeLink() {
    const { menu, page, history, location } = this.props;

    if (location.pathname === '/buero') {
      return <Link to={'/'} className={ClassNames('menu', 'link', 'dot')} />;
    }

    if (page.type !== 'Home' && page.type !== 'Overview') {
      return (
        <button
          className={ClassNames('menu', 'link', 'dot')}
          onClick={() => history.goBack()}
        />
      );
    }

    return menu.Items.map(({ UID, Title }) => (
      <Link
        key={UID}
        to={`/${UID}`}
        data-active={page.UID === UID}
        className={ClassNames('menu', 'link')}
      >
        {Title}
      </Link>
    ));
  }
}
export const Menu = withRouter(MenuWrapped);
export default Menu;



// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.tsx